<div class="container contenedor text-white">
  <div class="row">
    <div class="col-lg-12 text-center mb-5">
      <h1>CONSULTA DE AUTENTICIDAD DE TESTIMONIOS</h1>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-7 pl-lg-4">
          <div class="row mb-4">
            <div class="col-lg-12">
              <span style="font-size: 1.1rem; text-align: justify !important;">
                Los testimonios con firma digital emitidos por Notaría Ruth Alessandra Ramos Rivas, poseen certificación digital
                y firma con valor legal. Además cuentan con un sello de autenticidad.<br>
                Para validar su testimonio digital ingrese el código, como se muestra en la imagen.
              </span>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-sm-12 ">
              <label for="inputKardex">Ingrese Código (*)</label>
              <div class="input-group">
                <span class="input-group-text">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M12.354 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"></path>
                    <path d="M6.25 8.043l-.896-.897a.5.5 0 1 0-.708.708l.897.896.707-.707zm1 2.414l.896.897a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0-.708-.708L8.5 10.293l-.543-.543-.707.707z"></path>
                  </svg>
                </span>
                <input type="text" [(ngModel)]="codigo" class="form-control" maxlength="12" placeholder="..." autocomplete="off" (input)="funcionesService.validarInput($event.target)">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 form-group">
              <form (ngSubmit)="onSubmit()" [formGroup]="miFormulario">
                <!-- Otros campos del formulario -->

                <re-captcha
                  formControlName="recaptcha"
                  siteKey="6LcGtHcdAAAAAB2Gu10jGGOm-_Kb1RDLOEXAnX3-"
                  (resolved)="resolvedCaptcha($event)">
                </re-captcha>

                <button class="btn btn-primary btn-sm" type="submit">Enviar</button>
              </form>
            </div>
          </div>

          <div class="form-group" align="right">
            <button type="button" (click)="enviavalores()" class="btn btn-primary btn-lg btn-block">Verificar</button>
          </div>

        </div>
        <div class="col-lg-5 text-center">
          <div class="flexslider">
            <img src="assets/img/logo.png" class="img-fluid" alt="">

            <div class="eco-buttons mt-3" align="center">
              <div class="description-apt d-grid mb-5">

              </div>
            </div>
          </div>
          <div class="flexslider">
            <img src="assets/img/autenticidade.png" class="img-fluid" alt="">

            <div class="eco-buttons mt-3" align="center">
              <div class="description-apt d-grid mb-5">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
